<template>
  <div style="position: relative" class="video-agenda">
<!--    <img class="beauty2-wap" src="../../assets/images/beauty4.png" alt="">
    <img class="beauty3-wap" src="../../assets/images/beauty3.png" alt="">
    <img class="beauty4-wap" src="../../assets/images/beauty2.png" alt="">
    <img class="beauty5-wap" src="../../assets/images/beauty5.png" alt="">-->

    <div class="agenda-list-wap">

      <!--<div class="title-line"></div>-->

      <div class="agenda-list">
        <div v-for="(item,index) in newAgendaList" :key="item.agendaId" class="agenda-list-group">
          <div class="agenda-group-name " :class="{'no-top':index!=0}">{{ item.name }}</div>

          <div class="agenda-item" @click="checkReplay(list,index)" :class="list.isCurrent?'current':''"  v-for="(list,index) in item.item" :key="list.agendaId">
            <div class="current-icon"></div>
            <div class="date">
              <div>{{ list.startTimeDate }}-{{ list.endTimeDate }}</div>
              <div class="title" v-if="list.agendaGuest && list.agendaGuest.length>0" v-html="list.theme.replace('|&|','')"></div>
            </div>
            <div class="right-content" v-show="list.agendaGuest && list.agendaGuest.length>0" v-for="(guest, i) in list.agendaGuest" :key="i">
              <div class="head">
                <div class="head-img">
                  <img class="head-img2" :src="guest.head" alt="">
                </div>
              </div>
              <div class="content">

                <span class="name">{{ guest.name }}</span>
                <div class="name-position">
                  <span class="position">{{ guest.enterprise }} {{ guest.duty }}</span>
                </div>

              </div>
            </div>
            <div class="right-content" v-show="!list.agendaGuest || list.agendaGuest.length==0">
              <div class="content">
                <div class="right-title">{{list.theme.replace('|&|','')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="qrcode-zijie-wap">
      <img class="qr" src="../../assets/images/qrcode-zijie.png" alt="">
      <div>更多TikTok for Business</div>
      <div> 出海营销资讯</div>
    </div>
  </div>
</template>
<script>
import { $subscriber, cr, URLS} from "fire-wind-water";
import { validateState } from "@/common/joinMeeting";
import * as moment from "moment";
export default {
  name: "AgendaMetting",
  data() {
    return {
      isInfo: this.$route.path.indexOf("Info") > 0,
      webinarInfo: {},
      scheduleList: [],
      amList:[],
      pmList:[],
      userInfo:{},
      replaySwitch: 0,
    };
  },
  computed: {
    newAgendaList() {
      let newAgendaList = [];
      for (let i in window.agendaGroup) {
        newAgendaList.push({
          agendaId: Math.random(),
          name: i,
          item: this.getAgendaGroup(this.scheduleList, window.agendaGroup[i])
        })
      }
      return  newAgendaList;
    }
  },
  methods: {
    getUrlParam(sUrl, sKey) {
      // 返回?后面#前面的
      let sParam = sUrl.split("?")[1].split("#")[0];  // key=1&key=2&key=3&test=4
      // 进一步将参数分割为数组
      let arr = sParam.split("&"); // ["key=1","key=2","key=3","test=4"]
      // 结果
      let res;
      if (sKey) { // 如果指定参数
        // 结果为数组
        res = [];
        for (let i = 0; i < arr.length; i++) {
          // 分割为键值对
          let temp = arr[i].split("=");
          // 存储指定key值的结果
          if (temp[0] === sKey) {
            res.push(temp[1]);
          }
        }
        if (res.length === 1) {
          // 长度为1，返回字符串
          return res[0];
        } else if (res.length === 0) {
          // 长度为0，返回空字符串
          return "";
        } else {
          // 长度大于1返回数组
          return res;
        }

      } else { // 如果不指定参数
        // 结果为对象
        res = {};
        if (sParam === undefined || sParam === "") {
          return res;
        }
        for (let i = 0; i < arr.length; i++) {
          // 分割为键值对
          let temp = arr[i].split("=");
          // 判断是否已存在结果
          if (!(temp[0] in res)) {
            // temp[0]为键，temp[1]的数组为值
            res[temp[0]] = [];
          }
          // 使用变量动态访问对象属性用obj[a]不能用obj.a
          res[temp[0]].push(temp[1]);
        }

      }
      return res;
    },
    init() {
      let _this=this;
      $subscriber.subscribe("webinarInfo", data => {
        //把嘉宾的数据 和日常的数据组合一下
        this.replaySwitch = data.replaySwitch;
        cr.each(data.agendaList, d => {
          d.endTimeDate = moment(d.endTime * 1000).format("HH:mm");
          d.startTimeDate = moment(d.startTime * 1000).format("HH:mm");
          cr.each(d.agendaGuest, n => {
            cr.each(data.guestList, list => {
              if (list.webinarGuestId == n.webinarGuestId) {
                n.duty = list.duty; //"这是职务"
                n.enterprise = list.enterprise; //"这是公司"
                n.department = list.department; //"这是部门"
                n.head = list.realPath;
              }
            });
          });
        });
        let nuanchangNum = 0;
        cr.each({...data.agendaList}, d => {
          if(d.theme.indexOf('|&|')>-1){
            // d.theme = d.theme.replace('|&|','');
            d.isCurrent = true;
          }else{
            d.isCurrent = false;
          }
          d.theme=d.theme.replaceAll('^|^','</br>')
        })

        if(parseInt(window.currentGuestIndex)>-1 && data.agendaList[parseInt(window.currentGuestIndex)]){
          data.agendaList[parseInt(window.currentGuestIndex)].isCurrent = true;
        }
        data.agendaList.forEach((item,index)=>{
          item.timestamp = window.agendaTimestamp[index]
        });
        this.scheduleList = data.agendaList;
     /*   let newAgendaList = [];
        for (let i in window.agendaGroup) {
          console.log(i)    //输出 ： a   b  c
          newAgendaList.push({
            agendaId: Math.random(),
            name: i,
            item: this.getAgendaGroup(data.agendaList, window.agendaGroup[i])
          })
        }
        this.scheduleList = newAgendaList;*/
        // this.amList[2].isCurrent = true;
        // this.pmList[0].isCurrent = true;
      });

      $subscriber.subscribe("onTimeline", (data) => {
        let index = -1;
        if (data.content.indexOf('timeline') > -1) {
          index = parseInt(data.content.replace('timeline','')) - 1;
        }
        if (index > -1) {
          cr.each(this.scheduleList, d => {
            d.isCurrent = false;
          })
          this.scheduleList[index].isCurrent = true;
        }

        this.scheduleList = {...this.scheduleList};
      });

      $subscriber.subscribe('changeCurrentGuest', data => {

        let num = '';
        let isAm = true;
        // let isAm = true;
        data = data.split('|&|');
        num = data[1];

        if (data[0] && data[0].toLocaleUpperCase() == 'AM') {
          isAm = true;
        }
        if (data[0] && data[0].toLocaleUpperCase() == 'PM') {
          isAm = false;
        }
          this.amList.forEach((item, index) => {
            item.isCurrent = false;
            if (index == num && isAm) {
              item.isCurrent = true;
            }
          });
          this.pmList.forEach((item, index) => {
            item.isCurrent = false;
            if (index == num && !isAm) {
              item.isCurrent = true;
            }
          });


      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
        console.log("userInfo", this.userInfo);
      });
      $subscriber.subscribe("simulateClickEvent", data=>{
        this.scheduleList = this.scheduleList.map(item2=>{
          item2.isCurrent = false;
          return item2;
        })
        if(data.idx && this.scheduleList[data.idx] && this.scheduleList[data.idx]){
          this.scheduleList[data.idx].isCurrent = true;
        }
      });
      window.$sk.webinar.module({
        skPlayerStatus(res) {
          let data = res[0];
          if (data.content.data == "直播回放") {
            let time=''
            this.getTimeLine =  setInterval(()=>{
              if(window.$sk.webinar.sdk.player.nowVideo.videoType=='0'){
                time= window.$sk.webinar.sdk.player.plvLiveSdk.player.player.currentTime;
              }else {
                time= window.$sk.webinar.sdk.player.plvDomainSdk.j2s_getCurrentTime();
              }
              _this.getCurrentAgenda(time);
            },1000)

          }
        },
      })
    },
    async joinBtnClick(type) {
      let info = window.$sk.webinar.get().meetingInfo;
      //处理goToSignUpUrl
      if(info.goToSignUpUrl) {
        let back = decodeURIComponent(this.getUrlParam(info.goToSignUpUrl, 'returnUrl'));
        let url = encodeURIComponent(URLS.updateSearchParam('type', type, back));
        let url2 = URLS.updateSearchParam('returnUrl', url, info.goToSignUpUrl);
        info.goToSignUpUrl = url2;
      }
      //////



      let webinarInfo = Object.assign(this.webinarInfo, info);
      let userInfo = Object.assign(
        this.userInfo,
        window.$sk.webinar.get().user
      );
      //验证用户状态  审核中 未通过 无权限  会议已经关闭 会场未发布
      if (window.$sk.webinar.get().canJoin(webinarInfo, userInfo)) {
        if (window.$sk.webinar.get().canEnter(webinarInfo, userInfo)) {
          //可进入会场

          window.location.href =URLS.updateSearchParam('type',type,window.location.href.replace(
            "/meetingInfo",
            "/meeting"
          ));
        } else {
          let returnUrl = window.location.href;
          if (!webinarInfo.isClosed) {
            returnUrl = URLS.updateSearchParam('type',type,window.location.href.replace(
              "/meetingInfo",
              "/meeting"
            ));
          }
          if (
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needLogin &&
            !userInfo.isLogin &&
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needRegistration &&
            !userInfo.isRegistration
          ) {
            window.$sk.goto(
              webinarInfo.loginUrl +
              "sourceKey=" +
              URLS.getURL("sourceKey") +
              "&backUrl=" +
              encodeURIComponent(webinarInfo.goToSignUpUrl)
            );
          } else if (
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needLogin &&
            !userInfo.isLogin
          ) {
            window.$sk.goto(
              webinarInfo.loginUrl +
              "sourceKey=" +
              URLS.getURL("sourceKey") +
              "&backUrl=" +
              encodeURIComponent(returnUrl)
            );
          } else if (
            !webinarInfo.isClosed &&
            !webinarInfo.unLimit &&
            webinarInfo.needRegistration &&
            !userInfo.isRegistration
          ) {
            window.$sk.goto(webinarInfo.goToSignUpUrl);
          } else {
            window.$sk.goto(returnUrl);
          }
        }
      } else {
        if (this.webinarInfo.isOnDemand) {
          window.location.href = webinarInfo.demandUrl;
        } else {
          validateState(webinarInfo, this.userInfo);
        }
      }
    },
    checkReplay(item,index){
      console.log(index);
      if(this.replaySwitch != '1'){
        return;
      }
      this.scheduleList = this.scheduleList.map(item2=>{
        item2.isCurrent = false;
        if(item.theme == item2.theme){
          item2.isCurrent = true;
        }
        return item2;
      })
      console.log(' this.scheduleList', this.scheduleList);
      if(window.$sk.webinar.sdk.player.nowVideo.videoType=='0'){
        window.$sk.webinar.sdk.player.plvLiveSdk.player.seek(item.timestamp);
      }else {
        window.$sk.webinar.sdk.player.plvDomainSdk.j2s_seekVideo(item.timestamp);
      }

    },
    getAgendaGroup(data, arr) {
      let newArry = []
      arr.forEach((item) => {
        data[item] && newArry.push(data[item])
      });
      return newArry
    },
    getCurrentAgenda(time){
      let currentIndex=-1
      console.log('this.scheduleList',this.scheduleList);
      this.scheduleList.forEach((item,index)=>{
        if(item.timestamp<parseInt(time)|| item.timestamp==parseInt(time)){
          currentIndex=index
        }
      });
      this.scheduleList.forEach((item,index)=>{
        item.isCurrent = index === currentIndex
      });
    }
  },
  created() {
    this.init();
  }
};
</script>
